module.exports = __webpack_public_path__ + "img/19.dbae73a0.jpg";